/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/hpfs', children: 'hpfs' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/HPFSLink.js